import type { MetalPhotos } from '~/scopes/campaign/data/metals/types'

// A leaf module, like `footnotes.ts`: the components that paint a photo must not pull the
// 38-metal registry in behind them.

/** Resolves what the view renders: a hero only holds the first slot when no video does. */
export function metalPhotos(
  photos: MetalPhotos | undefined,
  hasVideo: boolean,
) {
  const hero = photos?.hero ?? null
  const firstBento = photos?.firstBento ?? []
  const secondBento = photos?.secondBento ?? []
  const ordered = [...(hero ? [hero] : []), ...firstBento, ...secondBento]

  return {
    hero: hasVideo ? null : hero,
    firstBento: hasVideo && hero ? [hero, ...firstBento] : firstBento,
    secondBento,
    // Deduplicated, and mapped to no particular photo — which is what lets an
    // uncredited photo sit between two credited ones without seeming to take a name.
    credits: [...new Set(ordered.flatMap((photo) => photo.credit ?? []))],
  }
}
